module.exports = __webpack_public_path__ + "img/Qi_Text.adabb2d1.svg";